
<template>
  <div class="hello">
      <transition name="fade">
            <div v-if="performingRequestForReset" class="loading">
                <p>Resetting Password..</p>
            </div>
        </transition>

    <b-container>
        <b-row style="margin-top:40px">
            <b-col>
                <h2>Forgot your Keg Seeker Password?</h2>
            </b-col>
        </b-row>

        <!-- Reset password form -->
        <b-row>
            <b-col>
                <form @submit.prevent class="password-reset">
                    <div v-if="!passwordResetSuccess" style="margin-top:10px">
                        <p>We will send you an email to reset your password</p>
                        <div class="input-group col-md-3  col-lg-6 mx-auto" style="margin-top:10px;">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Email</span>
                            </div>
                            <input type="email" class="form-control" v-model.trim="email"  placeholder="Email" aria-describedby="basic-addon1">
                        </div>
 
                    </div>
                    <div v-else>
                        <h1>Email Sent</h1>
                        <h4>Check your email for a link to reset your password</h4>
                    </div>
                </form>
            </b-col>
        </b-row>

        <b-row v-if="!passwordResetSuccess" style="margin-top:10px; width:100%; margin:auto; text-align:center">
            <b-col>
                <button style="text-align:center;margin-top:10px" @click="resetPassword()" class="button" >Reset Password</button>
            </b-col>
        </b-row>


        <!-- Password reset error -->
        <b-row v-if="errorMsg" style="color:red">
            <b-col>
                <h4>{{errorMsg}}</h4>
            </b-col>
        </b-row>

        <!-- Help -->
        <div style="text-align:center; margin-top:20px; color:#808080">
            <h6>Need More Help?</h6>
        </div>

        <!-- Help -->
        <b-row>
            <b-col>
                <div style="text-align:center; margin-top:20px">
                    <b-button style="margin-bottom:40px" variant = 'outline-dark'  tag="router-link" :to="{ path: '/contact' }"><font-awesome-icon icon="question" /> Contact Keg Seeker</b-button>
                </div>
            </b-col>
        </b-row>

    <footer><pagefooter/></footer>
    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../firebaseConfig.js')
import Pagefooter from './Pagefooter'

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
        Pagefooter,
    },

    data() {
        return {
            email:'',
            passwordResetSuccess:false,
            performingRequestForReset:false,
            errorMsg:'',

        }
    },

    methods:{
        resetPassword() {
                this.performingRequestForReset = true

                fb.auth.sendPasswordResetEmail(this.email).then(() => {
                    this.performingRequestForReset = false
                    this.passwordResetSuccess = true
                    this.errorMsg=""
                    this.email = ''
                }).catch(err => {
                    console.log(err)
                    this.performingRequestForReset = false
                    this.errorMsg = err.message
                })
            },
    },

    mounted(){
    },
}
</script>

